import { motion } from 'framer-motion'
import { useTheme } from '../hooks/useTheme'
import siteConfig from '../config/siteConfig'

interface HeaderProps {
  className?: string
}

export function Header({ className }: HeaderProps) {
  const theme = useTheme(state => state.getThemeStyles())

  return (
    <header className={`relative h-[20vh] ${className}`}>
      {/* Fundo com Efeito de Vidro */}
      <div className={`absolute inset-0 ${theme.effects.gradient.surface} ${theme.effects.blur.md}`} />
      
      {/* Malha de Pontos 3D */}
      <div className="absolute inset-0">
        <div className="relative w-full h-full">
          {[...Array(50)].map((_, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, scale: 0 }}
              animate={{ 
                opacity: [0.2, 0.5, 0.2],
                scale: [1, 1.2, 1],
                z: [0, 30, 0]
              }}
              transition={{
                duration: 3,
                repeat: Infinity,
                delay: i * 0.1,
                ease: 'easeInOut'
              }}
              className={`absolute w-1 h-1 ${theme.colors.primary.base} rounded-full`}
              style={{
                left: `${Math.random() * 100}%`,
                top: `${Math.random() * 100}%`,
                filter: 'blur(1px)'
              }}
            />
          ))}
        </div>
      </div>

      {/* Conteúdo Principal */}
      <div className={`relative container mx-auto px-4 h-full flex items-center justify-center ${theme.colors.text.primary}`}>
        <div className="text-center space-y-6 max-w-4xl">
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="text-7xl font-bold tracking-tight">
              <span className={theme.effects.gradient.text.primary}>
                {siteConfig.site.title1}
              </span>
            </h1>
            <motion.div
              initial={{ width: 0 }}
              animate={{ width: '100%' }}
              transition={{ duration: 1, delay: 0.5 }}
              className={`h-0.5 ${theme.effects.gradient.secondary} mx-auto my-4`}
            />
            <p className={`text-3xl font-light ${theme.effects.gradient.text.secondary}`}>
              {siteConfig.site.title2}
            </p>
          </motion.div>
        </div>
      </div>
    </header>
  )
}